module.exports = "/_next/static/images/award-info-bank-7efd0f55f2c0c684d30d6f09f08cbbca.png";